import './globals';
import ReactDOM from 'react-dom';
import React from 'react';
// third party
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';

// project imports
import App from './App';
import * as serviceWorker from 'serviceWorker';
import { store } from './store';

// style + assets

import 'assets/scss/style.scss';
import config from 'config';
const ProviderAny = Provider as any;

const win = (typeof window !== 'undefined' ? (window as any) : undefined) as any;
if (win) {
    win.React = win.React || React;
    win.global = win.global || win;
    if (!win.process) {
        win.process = { env: { NODE_ENV: process.env.NODE_ENV } };
    }
}

if ((module as any).hot) {
    (module as any).hot.accept();
}
// ==============================|| REACT DOM RENDER  ||============================== //

ReactDOM.render(
    <ProviderAny store={store}>
        <BrowserRouter basename={config.basename}>
            <App />
        </BrowserRouter>
    </ProviderAny>,
    document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
